import React from "react";
import {
  formatEntityStatusLabel,
  getEntityStatusStyle,
  getOrderStatusLabel,
  getOrderStatusStyle,
  getTransactionModeLabel,
  getTransactionModeStyle,
  normalizeStatusKey,
} from "../../utils/status";
import { Badge } from "../ui/badge";
import { cn } from "../../lib/utils";

type StatusBadgeProps = {
  status: unknown;
  variant?: "entity" | "order" | "mode";
  className?: string;
};

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  variant = "entity",
  className,
}) => {
  const style =
    variant === "order"
      ? getOrderStatusStyle(status)
      : variant === "mode"
        ? getTransactionModeStyle(status)
        : getEntityStatusStyle(status);
  const label =
    variant === "order"
      ? getOrderStatusLabel(status)
      : variant === "mode"
        ? getTransactionModeLabel(status)
        : formatEntityStatusLabel(status);

  return (
    <Badge
      variant="outline"
      className={cn(
        "max-w-full min-w-0 shrink-0 gap-1.5 border-0 font-medium whitespace-nowrap",
        className,
      )}
      style={{ background: style.bg, color: style.color }}
      data-status={normalizeStatusKey(status)}
      title={label}
    >
      <span
        className="h-1.5 w-1.5 shrink-0 rounded-full"
        style={{ background: style.color }}
        aria-hidden
      />
      <span className="truncate">{label}</span>
    </Badge>
  );
};

export default StatusBadge;
